import axios from 'axios';
import { auth } from '../../firebase';

export const deleteZone = async ({ zoneId, companyId }) => {
  console.log('DELETING ZONE: ' + zoneId);
  console.log('COMPANY: ' + companyId);
	const apiUrl = `${process.env.REACT_APP_FIREBASE_FUNCTION_HOSTNAME}/deleteZone`;
  const token = await auth.currentUser.getIdToken();
	try {
		const response = await axios.post(
			apiUrl,
			{
        zoneId,
        companyId
			},
			{
				headers: {
					'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
				},
				validateStatus: status => {
					return status >= 200 && status < 500;
				}
			}
		);
		return response;
	} catch (e) {
		throw e;
	}
};

export default deleteZone;
